import './scripts/modernizr';
import header from './scripts/header';
import replaceIcons from './scripts/icons';
import wordPressUI from './scripts/wordpress';

import accordions from './template-parts/blocks/accordions';
import accordionGroup from './template-parts/blocks/accordion-group';
import cardsModal from './template-parts/blocks/cards-modal';
import featureTextCarousel from './template-parts/blocks/feature-text-carousel';
import hoverList from './template-parts/blocks/hover-list';
import imageCarousel from './template-parts/blocks/image-carousel';
import imageContentCarousel from './template-parts/blocks/image-content-carousel';
import interactiveMap from './template-parts/blocks/interactive-map';
import projectFilters from './template-parts/blocks/projects';
import tabbedContent from './template-parts/blocks/tabbed-content';

declare global {
  interface Window {
    gmak: string; // gmak - Google Maps API Key
    initGoogleMaps: () => void;
    Sentry?: {
      captureException: (e: Error) => void;
    };
  }
}

export const docReady: (fn: () => void) => void = (fn) => {
  // see if DOM is already available
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

if (window.location.href.includes('post.php')) {
  setTimeout(() => {
    wordPressUI();
  }, 100);
} else {
  docReady(() => {
    [
      header,
      replaceIcons,
      accordions,
      accordionGroup,
      cardsModal,
      featureTextCarousel,
      hoverList,
      imageCarousel,
      imageContentCarousel,
      interactiveMap,
      projectFilters,
      tabbedContent,
    ].forEach((fn) => {
      try {
        fn();
      } catch (e) {
        console.error(e);
        try {
          if (
            typeof window.Sentry === 'object' &&
            typeof window.Sentry.captureException === 'function'
          ) {
            window.Sentry.captureException(e);
          }
        } catch (_e) {
          console.error('Failed to send error to Sentry');
          console.error(_e);
        }
      }
    });
  });
}
